// extracted by extract-css-chunks-webpack-plugin
module.exports = {"modalWrapper":"E38ua","modalBlock":"XtlB-","modalContent":"qbHCw","modalHeaderIcon":"m6itF","success":"e9MaZ","warning":"-MyRf","error":"RZ2v0"};